import {api} from "../api/index.js"
import store from "../store/index.js";
import base from "./base.js"
import wx from 'weixin-js-sdk'
var infoCode = '';
var commonApi={}
commonApi.PayURL=function(){
    if(commonData.getTitle()=='热读文选'||commonData.getTitle()=='热读书集'){
        return "https://content.jushoucat.com"//测试环境中台
    }else{
       return 'https://content.jushoucrm.cn'//正式环境中台
    }
},
commonApi.JumpURL=function(){
    if(commonData.getTitle()=='热读文选'||commonData.getTitle()=='热读书集'){
        return "http://dump.jushoumi.com/"//测试环境跳转
    }else{
       return 'http://jump.jushoumi.com/'//正式环境
    }
},
commonApi.setTitle=function(){
            document.title=commonData.getTitle();
            console.log(commonData.getTitle())
},
commonApi.share=function() {
    commonApi.setTitle();
    var realUrl =window.location.href;//window.location.href
        api.getSignature({realUrl:realUrl}).then(res => {
        if (res.status == 1) {
            commonApi.jweixinShare(res.data)
        }
    })
},
commonApi.jweixinShare=function(data) {
    var url = window.location.origin;
    wx.config({
        debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
        appId: data.appId, // 必填，公众号的唯一标识
        timestamp: data.timestamp, // 必填，生成签名的时间戳
        nonceStr: data.nonceStr, // 必填，生成签名的随机串
        signature: data.signature, // 必填，签名
        jsApiList: data.jsApiList, //必填，需要使用的JS接口列表
    openTagList: ['wx-open-launch-weapp', 'wx-open-subscribe'],
    });
    wx.error(function(res){
        console.log(res)
        // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
    })
    wx.ready(() => {
        wx.updateAppMessageShareData({ //测试分享到朋友
            title: data.productName, // 标题
            desc: data.shareText, // 分享描述
            link: url,
            imgUrl: data.sharePicture, // 分享图标
            success: () => {
                console.log('success')
            },
        })
    });
},
commonApi.insertClickReporting=function(messageType, clickMessId, channelRecordId, promotionCode) { //上报消息点击
    var params = {
        messageType: messageType,
        clickMessId: clickMessId,
        channelRecordId: channelRecordId,
        promotionCode: promotionCode
    }
    api.insertClickReporting(params).then(res => {
        if (res.status == 1) {}
    })
},
commonApi.getUserInfo=function(openid) {
    var params = {
        openid: openid
    }
    api.getUserInfo(params).then(res => {
        if (res.status == 1) {
            base.setStorage('nickName', res.data.nickname)
            base.setStorage('headimgUrl', res.data.headImgurl)
            base.setStorage('frequency', res.data.frequency)
            base.setStorage('isVip', res.data.isVip)
            base.setStorage('EndTime', res.data.vipEndDate)
            base.setStorage('currency', res.data.currency)
            base.setStorage('uid', res.data.id)
            base.setStorage('mobile', res.data.mobile)
            base.setStorage('isSign', res.data.isSign)
            base.setStorage('isTourist', res.data.isTourist);
            base.setStorage('city', res.data.city);
            base.setStorage('isWxAuthorized', res.data.isWxAuthorized)
        }
    })
},
commonApi.snsapiUserinfo=function() { //手动授权 snsapi_userinfo手动
    infoCode = base.GetUrlParam('code');
    console.log('snsapiUserinfo')
    api.getUserInfo().then(res => {
        if (res.status == 1) {
            if (res.data.isWxAuthorized==0&&res.data.city==1) {
                if (!infoCode) {
                    console.log(window.location.href)
                    let uri = encodeURIComponent(window.location.href);
                    window.location.href =
                        "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" + store.state.user.appid + "&redirect_uri=" + uri +
                        "&response_type=code&scope=snsapi_userinfo&state=state&wechat_redirect&connect_redirect=1#wechat_redirect"
                } else {
                    commonApi.snsapiRegister();
                }
            } else {
                base.setStorage('isWxAuthorized', res.data.isWxAuthorized)
                base.setStorage('city', res.data.city)
            }
        }
    })
},
commonApi.snsapiRegister=function(){ //手动授权获取isWxAuthorized
    var params = {
        code: infoCode
    }
    api.getToken(params).then(res => {
        if (res.status == 1) {
            base.setStorage('token', res.data.accessToken)
            base.setStorage('openid', res.data.openid)
            commonApi.getUserInfo(res.data.openid)
        }
    })
}
export {commonApi}


// WEBPACK FOOTER //
// ./src/common/cpmmonApi.js